export enum LabelTypeMetadata {
  NutritionFacts = 1,
  FrontOfPack = 2,
  SupplementFacts = 4,
  FSIS = 8,
  CautionarySideOfPack = 16,
  CautionaryFrontOfPack = 32,
}
